(function() {
    'use strict';

    angular
        .module('invesfleet')
        .controller('MaintenanceListController', MaintenanceListController);
    

    MaintenanceListController.$inject = [
		'$templateCache', 'mantenimientoFlotasService', '$scope', '$rootScope', '$state', '$filter'
    ];

    

	function MaintenanceListController($templateCache, mantenimientoFlotasService, $scope, $rootScope, $state, $filter){
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
        var templates = {
			accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
			rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
        };

        var row = { 
            'state' : 'Pte. vencimiento', 
            'maintenance' : 'ITV', 
            'vehicle' : '003 - 1662GGF', 
            'kmExpired': '6.000 km', 
            'daysExpired' : '367 días', 
            'maintenanceDate' : '04/03/2014', 
            'km' : '0 Km',  
            'actions' : 'edita | eliminar'
        };
        
        var vm = this;
        vm.gridData = [];
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,
            
            columnDefs: [

                {
                    field: 'estado',
                    displayName: 'Estado',
                    resizable: true
                },

                {
                    name: 'maintenance',
                    displayName: 'Mantenimiento',
                    resizable: true
                },

                {
                    field: 'vehicle',
                    displayName: 'Vehículo',
                    resizable: true
                },

                {
                     field: 'kmExpired',
                     displayName: 'Kms vencimiento',
                },

                {
                    field: 'daysExpired',
                    displayName: 'Días vencimiento',
                    resizable: true
                },

                {
                    field: 'fechaMantenimiento',
                    displayName: 'Fecha mantenimiento',
                    resizable: true
                },

                {
                    field: 'km',
                    displayName: 'Kilómetros',
                    resizable: true
                },

                {
                    field: 'actions',
                    displayName: 'Acciones',
                    minWidth: 110,
                    maxWidth: 125,
                    resizable: true,
                    cellClass: 'overflow',
                    cellTemplate: templates.accionesCellTemplate
                }

             ],
             data: 'gridData',
        };

        vm.goToEdit = goToEdit;

        (function () {
            loadData();
        })();

        function loadData(){
			mantenimientoFlotasService.getList().then(function (result) {
				$scope.gridData = result.data.list;
				vm.gridData = result.data.list;
			});
        }

        function goToEdit(man) {
			$state.go('flota.mantenimientos.editar', { 'id': man.mantenimientoId });
		}
    }

})();
